import Container from "./Container";
import { useBuy } from "@/context/buy";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { motion, AnimatePresence } from "framer-motion";
import { decryptInteger } from "@/Utils/encryptInteger";
import Image from "next/image";

export default function Header() {
  const router = useRouter();

  const { setDirectOpen, openModal } =
    useBuy();
  const [secondNav, setSecondNav] = useState(false);
  const [isTicketPage, setIsTicketPage] = useState(false);
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [loggedUserDetails, setLoggedUserDetails] = useState(null);

  useEffect(() => {
    if (
      (router.pathname && router.pathname.includes("tickets")) ||
      (router.pathname && router.pathname.includes("artist-ticket")) ||
      (router.pathname && router.pathname.includes("tickets"))
    ) {
      setIsTicketPage(true);
    } else {
      setIsTicketPage(false);
    }
    if (
      (router.pathname && router.pathname.includes("shows/[venue]")) ||
      (router.pathname && router.pathname.includes("/[artist]/[slug]"))
    ) {
      setSecondNav(true);
    } else {
      setSecondNav(false);
    }

    const userData = JSON.parse(decryptInteger(localStorage.getItem("user_data")));
    if (userData?.web_token ) {
      setLoggedUserDetails(userData);
    }

  }, [router.pathname]);

  const getAppLink = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      return "https://play.google.com/store/apps/details?id=com.qoncertapp.artist";
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "https://apps.apple.com/us/app/qoncert-live-shows/id1537042846";
    } else if (/Macintosh|Mac OS X/.test(userAgent)) {
      return "https://apps.apple.com/us/app/qoncert-live-shows/id1537042846";
    } else {
      return "https://www.qoncertapp.com/";
    }
  };

  function isAnyModalOpen() {
    let count = 0;
    for (const key in openModal) {
      if (openModal[key] === true) {
        count++;
      }
    }

    return count == 1 ? true : false;
  }

  const goHome = () => {
    if (router.pathname !== "/") {
      router.push("/");
    }
  };

  const shareShow = async () => {
    try {
      if (router.pathname && router.pathname.includes("/[artist]/[slug]")) {
        let shareData = {
          url: window.location.href,
        };
        if (navigator && navigator.share) {
          await navigator.share(shareData);
        }
        return;
      }

      const data = JSON.parse(
        decryptInteger(localStorage.getItem("current_data"))
      );
      const showData = data.data;
      const apiUrl = `/api/hello?url=${encodeURIComponent(showData.banner)}`;
      const response = await fetch(apiUrl);
      if (!response.ok) return;
      const blob = await response.blob();
      const file = new File([blob], "show.png", { type: "image/png" });
      if (navigator.share && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file] });
      }
    } catch (err) {
      console.error("Share error:", err);
    }
  };

  return (
    <div className=" bg-transparent ">
      <Container className={`relative ${isAnyModalOpen() ? "" : "z-[9999]"} `}>
        <div className="px-6 py-4 relative lg:pl-[75px] lg:pr-[48px] lg:py-[32px] flex xl:gap-[131px] items-center justify-between">
          {/* Logo */}
          {secondNav ? (
            <div>
              <p
                onClick={() => router.back()}
                className="lg:hidden cursor-pointer"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 19L8 12L15 5"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </p>
              <div className="hidden lg:block">
                <div
                  onClick={goHome}
                  className="cursor-pointer relative py-2 px-1"
                >
                  <Image
                    src="/assets/logo.webp"
                    alt="qoncert"
                    width={147}
                    height={44}
                    className="h-[44px] object-contain w-[147px]"
                    priority
                  />
                </div>
              </div>
            </div>
          ) : (
            <div onClick={goHome} className="cursor-pointer relative py-2 px-1">
              <Image
                src="/assets/logo.webp"
                alt="qoncert"
                width={147}
                height={44}
                className="h-[44px] object-contain w-[147px]"
                priority
              />
            </div>
          )}

          {/* Responsive Bar (Menu Icon) */}
          <div
            className="lg:hidden items-center flex gap-5"
            onClick={() => {
              if (!secondNav) setIsNavOpen(true);
            }}
          >
            {loggedUserDetails?.web_token && (
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  router.push("/dashboard");
                }}
                className="flex cursor-pointer gap-2 items-center"
              >
                <img
                  className="w-[30px] aspect-square object-cover border object-bottom border-white rounded-full"
                  src={
                    loggedUserDetails?.profile
                      ? loggedUserDetails?.profile
                      : "/assets/usr.webp"
                  }
                  alt=""
                  loading="eager"
                />
              </div>
            )}
            {secondNav ? (
              <div onClick={() => shareShow()}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.68387 13.3419C8.88616 12.9381 9 12.4824 9 12C9 11.5176 8.88616 11.0619 8.68387 10.6581M8.68387 13.3419C8.19134 14.3251 7.17449 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.17449 9 8.19134 9.67492 8.68387 10.6581M8.68387 13.3419L15.3161 16.6581M8.68387 10.6581L15.3161 7.34193M15.3161 7.34193C15.8087 8.32508 16.8255 9 18 9C19.6569 9 21 7.65685 21 6C21 4.34315 19.6569 3 18 3C16.3431 3 15 4.34315 15 6C15 6.48237 15.1138 6.93815 15.3161 7.34193ZM15.3161 16.6581C15.1138 17.0619 15 17.5176 15 18C15 19.6569 16.3431 21 18 21C19.6569 21 21 19.6569 21 18C21 16.3431 19.6569 15 18 15C16.8255 15 15.8087 15.6749 15.3161 16.6581Z"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            ) : (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3.59961 6.00078C3.59961 5.33804 4.13687 4.80078 4.79961 4.80078H19.1996C19.8624 4.80078 20.3996 5.33804 20.3996 6.00078C20.3996 6.66352 19.8624 7.20078 19.1996 7.20078H4.79961C4.13687 7.20078 3.59961 6.66352 3.59961 6.00078Z"
                  fill="white"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3.59961 12.0008C3.59961 11.338 4.13687 10.8008 4.79961 10.8008H19.1996C19.8624 10.8008 20.3996 11.338 20.3996 12.0008C20.3996 12.6635 19.8624 13.2008 19.1996 13.2008H4.79961C4.13687 13.2008 3.59961 12.6635 3.59961 12.0008Z"
                  fill="white"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M10.7996 18.0008C10.7996 17.338 11.3369 16.8008 11.9996 16.8008H19.1996C19.8624 16.8008 20.3996 17.338 20.3996 18.0008C20.3996 18.6635 19.8624 19.2008 19.1996 19.2008H11.9996C11.3369 19.2008 10.7996 18.6635 10.7996 18.0008Z"
                  fill="white"
                />
              </svg>
            )}
          </div>

          {/* Responsive Navigation */}
          <AnimatePresence>
            {isNavOpen && (
              <>
                <motion.div
                  className="fixed inset-0 bg-[#08080ab7] z-40"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  onClick={() => setIsNavOpen(false)}
                />
                <motion.div
                  initial={{ y: "-100%" }}
                  animate={{ y: 0 }}
                  exit={{ y: "-100%" }}
                  transition={{ duration: 0.4, ease: "easeInOut" }}
                  className="fixed top-0 left-0 right-0 z-50 pt-[7px]  rounded-b-[14px] shadow-lg"
                >
                  <div className="flex justify-end px-4 mb-2">
                    <div
                      className="w-10 h-10 rounded-full bg-[#252933] text-[#6A798F] text-2xl flex items-center justify-center cursor-pointer"
                      onClick={() => setIsNavOpen(false)}
                    >
                      x
                    </div>
                  </div>

                  <ul className="flex bg-[#1F222A] mx-10 px-5 py-7 rounded-[14px] flex-col gap-4 text-white">
                    <li
                      className={`py-3 pl-6 rounded-lg ${
                        router.pathname === 0 ? "bg-[#252933]" : ""
                      }`}
                    >
                      <p
                        onClick={() => router.push("/shows")}
                        className="font-bold text-lg"
                      >
                        Shows
                      </p>
                    </li>

                    <li
                      className={`py-3 pl-6 rounded-lg ${
                        router.pathname === 1 ? "bg-[#252933]" : ""
                      }`}
                    >
                      <p
                        onClick={() => router.push("/tours")}
                        className="font-bold text-lg"
                      >
                        Tours
                      </p>
                    </li>

                    <li
                      className={`py-3 pl-6 rounded-lg ${
                        router.pathname === 2 ? "bg-[#252933]" : ""
                      }`}
                    >
                      <p
                        onClick={() => router.push("/for-artists")}
                        className="font-bold text-lg"
                      >
                        For Artists
                      </p>
                    </li>
                    {!loggedUserDetails?.web_token && (
                      <li
                        onClick={() => {
                          sessionStorage.setItem("last_url", window.location.pathname + window.location.search);
                          router.push("/login");
                          setDirectOpen(true);
                          setIsNavOpen(false);
                        }}
                        className={`py-3 pl-6 rounded-lg `}
                      >
                        <p className="font-bold text-lg">Login</p>
                      </li>
                    )}

                    <div className="mt-6">
                      <button
                        onClick={() => {
                          window.open(getAppLink(), "_blank");
                        }}
                        className="w-full py-3 font-extrabold text-base text-black bg-white rounded-lg"
                      >
                        GET THE APP
                      </button>
                    </div>
                  </ul>
                </motion.div>
              </>
            )}
          </AnimatePresence>

          {/* Desktop Navigation */}
          <nav className="hidden lg:block">
            <ul
              className={`flex lg:gap-[60px] font-urbanist ${
                isTicketPage ? "hidden" : ""
              }`}
            >
              <li>
                <p
                  onClick={() => router.push("/shows")}
                  className={`font-[700] cursor-pointer lg:text-2xl pb-[2px] border-b-2 ${
                    router.pathname === "/shows"
                      ? "border-white"
                      : "border-transparent"
                  }`}
                >
                  Shows
                </p>
              </li>

              <li>
                <p
                  onClick={() => router.push("/tours")}
                  className={`font-[700] cursor-pointer lg:text-2xl pb-[2px] border-b-2 ${
                    router.pathname === "/tours"
                      ? "border-white"
                      : "border-transparent"
                  }`}
                >
                  Tours
                </p>
              </li>

              <li>
                <p
                  onClick={() => router.push("/for-artists")}
                  className={`font-[700] cursor-pointer lg:text-2xl pb-[2px] border-b-2 ${
                    router.pathname === "/for-artists"
                      ? "border-white"
                      : "border-transparent"
                  }`}
                >
                  For Artists
                </p>
              </li>
              <li className=" hidden xl:block ">
                <p className="w-[40px] opacity-0">Testing3</p>
              </li>
            </ul>
          </nav>

          {/* Buttons */}
          <div className="hidden min-w-[288.88px] lg:block">
            {loggedUserDetails?.web_token ? (
              <div
                onClick={() => {
                  router.push("/dashboard");
                }}
                className="flex cursor-pointer justify-end gap-2 items-center"
              >
                <div className="w-[50px] aspect-square border-2 border-white rounded-full overflow-hidden flex justify-center items-center bg-gray-400">
                  {!loggedUserDetails?.profile?.trim() ? (
                    <div
                      className="w-full h-full flex justify-center items-center text-white text-lg font-bold"
                      style={{
                        background:
                          "linear-gradient(92.34deg, #fa2cb4 6.54%, #bc17d9 52.63%, #7f03ff 109.97%)",
                      }}
                    >
                      {loggedUserDetails?.name
                        ?.charAt(0)
                        ?.toUpperCase() ?? "U"}
                    </div>
                  ) : (
                    <img
                      className="w-full h-full object-cover object-bottom"
                      src={loggedUserDetails.profile}
                      alt="Profile"
                    />
                  )}
                </div>
                <div>
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.72473 7.14131C3.94662 6.91942 4.29383 6.89925 4.53851 7.0808L4.60861 7.14131L10 12.5324L15.3914 7.14131C15.6133 6.91942 15.9605 6.89925 16.2052 7.0808L16.2753 7.14131C16.4972 7.3632 16.5173 7.71042 16.3358 7.9551L16.2753 8.02519L10.4419 13.8585C10.2201 14.0804 9.87284 14.1006 9.62816 13.919L9.55806 13.8585L3.72473 8.02519C3.48065 7.78112 3.48065 7.38539 3.72473 7.14131Z"
                      fill="#F9F9F9"
                    />
                  </svg>
                </div>
              </div>
            ) : (
              <div className="flex min-w-max gap-6">
                <button
                  onClick={() => {
                    sessionStorage.setItem("last_url", window.location.pathname + window.location.search);
                    router.push("/login");
                    setDirectOpen(true);
                  }}
                  className="py-2  min-w-max font-extrabold text-[22px] px-6 rounded-2xl capitalize border-white"
                >
                  Log in
                </button>
                <button
                  onClick={() => {
                    window.open(
                      "https://play.qoncertapp.com/more-shows",
                      "_blank"
                    );
                  }}
                  className="py-2 w-[190.88px] min-w-max max-h-[54px] font-extrabold text-[20px]  px-7 text-black bg-white rounded-2xl"
                >
                  Book a Show
                </button>
              </div>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
}
